import { Modal } from 'foundations-components/transitional/components/Modal';
import FirstStep from '../FirstStep';
import SecondStep from '../SecondStep';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import ThirdStep from '../ThirdStep';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Paths, StepsMap } from '../Routes';
import { useEffect } from 'react';
import { useSignup } from '../../hooks/useSignup';
import { getIsMobile } from '../../utils/deviceUtils';
import { WizardMobileHeader } from './WizardMobileHeader';
import { WizardMobileFooter } from './WizardMobileFooter';
import { NextButton } from './NextButton';
import { WizardStep, WizardHeaderWithOverview, Wizard as FoundationsWizard } from 'foundations-components/transitional/components/Wizard';
import { MessageUtils } from 'feature-unboxing-common';
import { IframeUtils } from 'feature-unboxing-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Wizard() {
  const {
    step
  } = useParams();
  const {
    search
  } = useLocation();
  const history = useHistory();
  const {
    signup
  } = useSignup();
  const isMobile = getIsMobile();
  const stepIndex = StepsMap.indexOf(`/${step}`);
  useEffect(() => {
    if (stepIndex < 0) {
      history.push({
        pathname: StepsMap[0],
        search
      });
    }
  }, [stepIndex, history, search]);
  if (stepIndex < 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(Modal, {
    use: "fullscreen",
    children: /*#__PURE__*/_jsxs(FoundationsWizard, {
      defaultHeading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.wizardHeading"
      }),
      headerComponent: isMobile ? WizardMobileHeader : WizardHeaderWithOverview,
      stickyHeader: false,
      stepIndex: StepsMap.indexOf(`/${step}`),
      onStepIndexChange: event => {
        history.push({
          pathname: StepsMap[event.target.value],
          search
        });
      },
      onConfirm: () => void signup(),
      onReject: () => {
        if (IframeUtils.isInIframe()) {
          MessageUtils.sendCloseIframeMessage();
        } else {
          history.push({
            pathname: Paths.WIZARD.replace('/:step', StepsMap[0]),
            search
          });
        }
      },
      backable: true,
      cancellable: true,
      defaultNextButton: /*#__PURE__*/_jsx(NextButton, {
        step: step
      }),
      defaultDoneButton: /*#__PURE__*/_jsx(NextButton, {
        step: step,
        isDone: true
      }),
      footerComponent: isMobile ? WizardMobileFooter : undefined,
      children: [/*#__PURE__*/_jsx(WizardStep, {
        name: I18n.text('app.firstStep.stepName'),
        children: /*#__PURE__*/_jsx(FirstStep, {})
      }), /*#__PURE__*/_jsx(WizardStep, {
        name: I18n.text('app.secondStep.stepName'),
        children: /*#__PURE__*/_jsx(SecondStep, {})
      }), /*#__PURE__*/_jsx(WizardStep, {
        name: I18n.text('app.thirdStep.stepName'),
        children: /*#__PURE__*/_jsx(ThirdStep, {})
      })]
    })
  });
}